import React from 'react';
import { Col, Container, Row } from '@yme/atoms/grid';
import { Skeleton } from '@yme/common/components/skeletons';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { FlexWrapper } from '@yme/tokens/flexTokens';
export function ProductCarouselSkeleton() {
    const { isMobileView, isTabletView } = useWindowSize();
    return (React.createElement(Container, null,
        React.createElement(Row, { mb: "30px", justifyContent: "space-between" },
            React.createElement(Col, { lg: 3, md: 3, sm: 3 },
                React.createElement(Skeleton, { skeletonProps: {
                        height: 40,
                    } })),
            !isMobileView && (React.createElement(Col, { lg: 2, md: 2 },
                React.createElement(FlexWrapper, { isFullWidth: true, justifyContent: "flex-end" },
                    React.createElement(Skeleton, { skeletonProps: {
                            width: 36,
                            height: 36,
                            count: 2,
                            inline: true,
                            circle: true,
                            style: {
                                marginLeft: '12px',
                            },
                        } }))))),
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12 },
                React.createElement(Skeleton, { skeletonProps: {
                        height: isMobileView ? 336 : isTabletView ? 296 : 428,
                    }, wrapperProps: {
                        mbM: 24,
                        mbS: 16,
                    } })))));
}
